import React from "react";
import { BrowserRouter } from "react-router-dom";
import { render } from "react-dom";

import Application from "./modules/application/Application";

render(
  React.createElement(
    BrowserRouter,
    { basename: "/" },
    React.createElement(Application)
  ),
  document.getElementById("app")
);
